<template>
    <AppLayout :title="article.title">
        <ConfirmDialog></ConfirmDialog>
        <template v-slot:main>
            <ShareThis/>
            <div class="section-row">
                <div class="main-post">
                    <h1 class="text-2xl" v-html="title"></h1>
                    <div v-if="categoriesOptions.length !== 0">
                        <span v-for="category in categoriesOptions"
                              :key="category.id"
                              class="bg-blue-800 text-white text-sm py-1 px-2 border-round mr-3">{{ category.name }}
                      </span>

                    </div>
                    <div class="pt-2 time">
                        <i class="pi pi-calendar"></i>
                        {{ date(article.publication_date) }}
                    </div>

                    <div class="thumbnail thumbnail-desktop pb-3 pt-3">
                        <picture>
                            <source :srcset="cdnUrl('webp') + ', ' + cdnUrl('jpg')"
                                    media="(max-width: 450px)">
                            <img :alt="article.title"
                                 :src="cdnUrl('jpg')"
                                 class="thumbnail-fit mobile-img desktop-img"
                            />
                        </picture>
                    </div>

                    <h2 class="text-xl" v-html="firstSentence"></h2>
                    <div id="article_body" class="content" v-html="afterFirstSentence"></div>
                    <div v-if="hasMore" class="mt-2">
                        <a id="read-more" rel="nofollow" @click="readMore()">{{ __('Read More...') }}</a>
                    </div>
                    <!--                    <AdComponent />-->
                </div>
            </div>

            <Author :newspaper="newspaper"/>

            <CommentSection :comments="comments"/>
            <ReplyForm :article="article"/>
            <RelatedArticles :articles="related"/>
        </template>
    </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/NewsPortal/AppLayout.vue";
import RelatedArticles from '@/Components/NewsPortal/RelatedArticles.vue';
import Author from "@/Components/NewsPortal/Author.vue";

import moment from "moment-timezone";

import AdComponent from '@/Components/AdComponent.vue';
import CommentSection from '@/Components/NewsPortal/CommentSection.vue';
import ReplyForm from '@/Pages/NewsPortal/Article/Partials/ReplyForm.vue';
import ShareThis from '@/Components/Primitives/ShareThis.vue';

export default {
    components : {
        ShareThis,
        ReplyForm,
        CommentSection,
        AdComponent,
        AppLayout,
        Author,
        RelatedArticles,
    },
    props      : {
        thumbnail     : String,
        article       : Object,
        categories    : Object,
        newspaper     : Object,
        allCategories : Object,
        comments      : Object,
        related       : Object,
    },
    data() {
        return {
            hasMore            : true,
            formArticleVisible : false,
            action             : "",
            thumbnailsPath     : '/resources/images/thumbnail/',
        };
    },
    computed : {
        firstSentence() {
            return this.body.split('.')[0];
        },
        afterFirstSentence() {
            return this.body.substring(this.firstSentence.length + 1);
        },
        body() {
            let maxLength = 1000;
            if (this.newspaper.slug === 'cyprus-news' || this.article.id === 388452) {
                this.hasMore = false;
                return this.article.body;
            }

            if (this.article.summary) {
                return this.article.summary;
            }

            const parser = new DOMParser();
            const doc    = parser.parseFromString(this.article.body, 'text/html');

            const images = doc.querySelectorAll('img');
            images.forEach(img => img.parentNode.removeChild(img));

            const scripts = doc.querySelectorAll('script');
            scripts.forEach(script => script.parentNode.removeChild(script));

            const anchors = doc.querySelectorAll('a');
            anchors.forEach(anchor => {
                const text = document.createTextNode(anchor.textContent);
                anchor.parentNode.replaceChild(text, anchor);
            });

            let cleanedHtml = doc.body.innerHTML;

            if (cleanedHtml.length < maxLength) {
                maxLength = Math.floor(cleanedHtml.length / 2);
            }

            let endIndex = cleanedHtml.lastIndexOf(' ', maxLength);

            endIndex = endIndex === -1 ? maxLength : endIndex;

            return cleanedHtml.substring(0, endIndex) + ' [...]';

        },
        categoriesOptions() {
            if (this.article.category) return [this.article.category];
            return [];
        },
        title() {
            return this.article.title.replace(/(?<!&)(#[0-9]+;)/g, "&$1");
        },
    },
    methods  : {
        readMore() {
            window.open(this.article.URL, '_blank')
        },
        date(date) {
            return moment(date).format("D MMM YYYY, H:mm");
        },
        cdnUrl(type) {
            if (this.$page.props.env !== 'production') {
                return `${this.thumbnailsPath}${this.article.id}.jpg`;
            }


            let imgUrl = this.thumbnail;

            try {
                imgUrl = btoa(this.thumbnail);
            } catch (e) {
            }

            return `https://cyprusnews.live/cdn?path=${imgUrl}&width=573&height=323&format=${type}`;
        }

    }
};
</script>

<style scoped>

.thumbnail {
    min-height      : 180px;
    display         : flex;
    justify-content : center;
    align-items     : center;
}

.mobile-img {
    height : 180px;
}

@media (min-width : 768px) {
    .desktop-img {
        height : 380px;
    }

    .thumbnail-desktop {
        min-height : 380px;
    }
}

.thumbnail-fit {
    max-width : 100%;
}

.time {
    color : rgb(92, 92, 92);
}

.content ::v-deep(img) {
    width  : 100%;
    height : "auto";
}

.content ::v-deep(iframe) {
    width  : 100%;
    height : "auto";
}

#read-more:hover {
    cursor : pointer;
}

</style>
